import { computed, observable, makeObservable } from "mobx";
import { fromPromise, type IPromiseBasedObservable } from "mobx-utils";

import Api from "nvent-web/services/Api";
import { type Installer } from "nvent-web/types/Installer";

export class TeamInstallersStore {
  installersPromise?: IPromiseBasedObservable<Installer[]>;

  get installers() {
    if (!this.installersPromise) {
      return [];
    }

    return this.installersPromise.case({
      fulfilled: (installers) => installers,
      pending: () => [],
      rejected: () => [],
    });
  }

  get installersById() {
    return observable.map<string, Installer>(
      this.installers.map((installer) => [installer.id, installer])
    );
  }

  get hasMultipleInstallers() {
    return this.installers.length > 1;
  }

  constructor(private api: Api) {
    makeObservable(this, {
      installersPromise: observable,
      installers: computed,
      installersById: computed,
      hasMultipleInstallers: computed,
    });
  }

  loadInstallers(force = false) {
    if (force || !this.installersPromise) {
      this.installersPromise = fromPromise(
        this.api.team.installers.getAll().then(({ data }) => data)
      );
    }

    return this.installersPromise;
  }
}
